import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { ChatContext } from 'buyside/components/presentation/ChatLayout/chatLayout';
import ChatMessages from 'buyside/components/presentation/ChatLayout/Chat/ChatMessages/chatMessages';
import ChatMessageForm from 'buyside/components/presentation/ChatLayout/Chat/ChatMessageForm/chatMessageForm';
import ChatMessagesHeader from 'buyside/components/presentation/ChatLayout/Chat/ChatMessagesHeader/chatMessagesHeader';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { useChatQuery } from 'interfaces/graphql-typings';

const Chat: React.FC = () => {
  const { chatId } = useParams();

  const chatContext = useContext(ChatContext);

  const { data, error, loading, fetchMore } = useChatQuery({
    variables: { id: `${chatId}` },
    fetchPolicy: 'network-only'
  });

  if (loading) return <LoadingSpinner />;

  if (error) throw error;
  if (!data?.chat) throw new Error();

  if (!chatContext) throw new Error();

  const { canManageMessages, canViewIdeas, currentUserId } = chatContext;
  const {
    canCurrentUserChatPublicly,
    chatMessagesCount,
    chatMessages,
    chattableName,
    chattableUrl
  } = data.chat;

  return (
    <>
      <ChatMessagesHeader headerName={chattableName} headerUrl={chattableUrl} />
      <ChatMessages
        canManageMessages={canManageMessages}
        canViewIdeas={canViewIdeas}
        chatMessages={chatMessages}
        chatMessagesCount={chatMessagesCount}
        currentUserId={currentUserId}
        fetchMore={fetchMore}
      />
      <ChatMessageForm
        canChatPublicly={canCurrentUserChatPublicly}
        canManageMessages={canManageMessages}
        canViewIdeas={canViewIdeas}
      />
    </>
  );
};

export default Chat;
